import { useState, useCallback } from 'react'
import { PageGiveawayTabsItem } from '@/types/codegen-contentful'
import { useGiveawayContext } from '../../../../context/GiveawayContext'
import { SCROLL_BEHAVIOR_CONFIG } from '../constants'
import type { UseGiveawayTabsReturn } from '../types'
import { useTabMappings } from './useTabMappings'

export const useGiveawayTabs = (): UseGiveawayTabsReturn => {
  const {
    content,
    selectedIndex,
    setSelectedIndex,
    isActive,
    tickets,
    entryVariantId,
    tabsContainerRef,
    desktopTicketContainerRef,
    detailsContainerRef,
    faqContainerRef,
    prizesContainerRef,
    theatricalSlug,
  } = useGiveawayContext()

  const [activeTab] = useState<NonNullable<PageGiveawayTabsItem['__typename']> | null>(null)

  const { refs } = useTabMappings({ detailsContainerRef, faqContainerRef, prizesContainerRef })

  const handleTabChange = useCallback(
    (index: number) => {
      setSelectedIndex(index)
      tabsContainerRef.current?.scrollIntoView(SCROLL_BEHAVIOR_CONFIG)
    },
    [setSelectedIndex, tabsContainerRef],
  )

  const shouldShowTicketSection = !!(isActive && tickets && entryVariantId)

  return {
    tabs: content.tabsCollection?.items,
    activeTab,
    selectedIndex,
    handleTabChange,
    isActive,
    tabsContainerRef,
    desktopTicketContainerRef,
    shouldShowTicketSection,
    refs,
    tickets,
    entryVariantId,
    theatricalSlug,
  }
}
